import React, { useState } from 'react';
import SlogoBranca from '../../../images/slogo-branca.png';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CloseIcon from '@material-ui/icons/Close';

const MenuIcon = (props) => (
  <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.99999 2H19C19.5523 2 20 1.55228 20 1C20 0.447715 19.5523 0 19 0H0.99999C0.447706 0 -9.53674e-06 0.447715 -9.53674e-06 1C-9.53674e-06 1.55228 0.447706 2 0.99999 2ZM19 9.99992H0.99999C0.447706 9.99992 -9.53674e-06 10.4476 -9.53674e-06 10.9999C-9.53674e-06 11.5522 0.447706 11.9999 0.99999 11.9999H19C19.5523 11.9999 20 11.5522 20 10.9999C20 10.4476 19.5523 9.99992 19 9.99992ZM0.99999 5.00008H19C19.5523 5.00008 20 5.4478 20 6.00008C20 6.55237 19.5523 7.00008 19 7.00008H0.99999C0.447706 7.00008 -9.53674e-06 6.55237 -9.53674e-06 6.00008C-9.53674e-06 5.4478 0.447706 5.00008 0.99999 5.00008Z" fill={props.color ? props.color : "white"} />
  </svg>
);

const Header = (props) => {

  const isMobile = useMediaQuery('(min-width:600px)');
  const initialState = {
    menu: false,
    sistemas: false,
    open: false
  }
  const [openObj, setOpenObj] = useState(initialState);

  if (!isMobile) {
    return (
      <>
        <nav style={{ backgroundColor: '#005EB8', padding: '0 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div onClick={() => setOpenObj({ ...initialState, open: true, menu: true })} style={{ display: 'flex', alignItems: 'center', zIndex: 99, width: 50, cursor: 'pointer', height: 30 }}>
            <MenuIcon />
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={SlogoBranca} width={68} height={36.26} alt='icone de logo branca'/>
          </div>
        </nav>
        {openObj.open &&
          <div style={{ position: 'fixed', zIndex: 99, backgroundColor: 'rgba(0,0,0,0.5)', top: 0, left: 0, width: '100vw', height: '100vh' }}>
            <div onClick={() => setOpenObj({ ...initialState })} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh' }}></div>
            <div style={{ position: 'absolute', width: 56, height: '100vh', top: 0, left: 0, backgroundColor: '#005EB8' }}>
              <div onClick={() => setOpenObj({ ...initialState, open: true, menu: true })} style={{ backgroundColor: openObj.menu ? '#F0F6FE' : '#005EB8', width: 56, height: 56, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <MenuIcon color={openObj.menu ? '#005EB8' : '#fff'} />
              </div>
              {/* <div onClick={() => setOpenObj({ ...initialState, open: true, sistema: true })} style={{ backgroundColor: openObj.sistema ? '#F0F6FE' : '#005EB8', width: 56, height: 56, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <SistemasIcon noMargin color={openObj.sistema ? '#005EB8' : '#fff'} />
              </div> */}
            </div>
            {openObj.menu &&<div style={{ position: 'absolute', left: 56, top: 0, width: 204, height: '100vh', padding: 16, backgroundColor: '#F0F6FE' }}>
              <div style={{ display: 'flex' }}>
                <span style={{ width: 152, color: '#005EB8', fontSize: 19, fontWeight: 'bold' }}>Atendimento ao cliente</span>
                <CloseIcon onClick={() => setOpenObj({ ...initialState })} style={{ fontSize: 16, color: '#005EB8', cursor: 'pointer' }} />
              </div>
              <span style={{ color: '#005EB8', fontSize: 16, paddingTop: 16, display: 'block' }}>Preencher formulário</span>
            </div>}
            {/* {openObj.sistema && <div style={{ position: 'absolute', left: 56, top: 0, width: 204, height: '100vh', padding: 16, backgroundColor: '#F0F6FE' }}>
              <div style={{ display: 'flex' }}>
                <span style={{ width: 152, color: '#005EB8', fontSize: 19, fontWeight: 'bold' }}>Sistemas e outros serviços</span>
                <CloseIcon onClick={() => setOpenObj({ ...initialState })} style={{ fontSize: 16, color: '#005EB8', cursor: 'pointer' }} />
              </div>
              <div style={{width:161, color:'#005EB8'}}>
                <Typography style={{padding:'8px 0'}}>Sistema de Gestão Operacional - SGO</Typography>
                <Typography style={{padding:'8px 0'}}>Sistema de Apoio ao Processo Decisório - SEAP</Typography>
                <Typography style={{padding:'8px 0'}}>SSistema de Gestão de Fornecedores - SGF</Typography>
                <Typography style={{padding:'8px 0'}}>Sistema de Metas Individuais e de Equipe - SGM</Typography>
                <Typography style={{padding:'8px 0'}}>Sistema de Gestão Estratégica - SGE</Typography>
                <Typography style={{padding:'8px 0'}}>Universidade Corporativa - UC</Typography>
                <span style={{float:'right', color:'#005EB8', fontWeight:'bold', fontSize:13, display:'flex', alignItems:'center'}}>Ver todos <ArrowRightAltIcon/></span>
              </div>
            </div>} */}
          </div>
        }
      </>
    )
  }

  return (
    <nav style={{ backgroundColor: '#005EB8', padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={SlogoBranca} width={68} height={36.26} alt='icone de logo branca'/>
        <Typography style={{ color: '#fff', fontWeight: 'bold', paddingLeft: 36, height: 30 }}>Atendimento ao cliente</Typography>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', zIndex: 99 }}>
        {/* <span onMouseEnter={() => setUselessHover(true)} onMouseLeave={() => setUselessHover(false)} style={{ color: '#fff', display: 'flex', alignItems: 'center', paddingRight: 16, position: 'relative', cursor: 'pointer' }}>
          <SistemasIcon />  Sistemas
          {uselessHover && <div style={{ position: 'absolute', left: -350, zIndex:99, top:0 }}>
            <div style={{ backgroundColor: '#fff', boxShadow: '0px 8px 12px rgba(20, 46, 82, 0.2)', border: '1px solid #CFE2FC', width: 516, marginTop: 41, borderRadius: 4, padding: 24, boxSizing: 'border-box' }}>
              <Typography style={{ color: '#617385', fontSize: 13, }}>Veja os sistemas e outros serviços para colaboradores do Sebrae:</Typography>
              <div style={{ paddingTop: 28 }}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <Typography style={{ color: '#005EB8', fontSize: 16, }}>Sistema de Gestão Operacional - SGO</Typography>
                  </Grid>
                  <Grid item sm={6}>
                    <Typography style={{ color: '#005EB8', fontSize: 16, }}>Sistema de Apoio ao Processo Decisório - SEAP</Typography>
                  </Grid>
                  <Grid item sm={6}>
                    <Typography style={{ color: '#005EB8', fontSize: 16, }}>Sistema de Gestão de Fornecedores - SGF</Typography>
                  </Grid>
                  <Grid item sm={6}>
                    <Typography style={{ color: '#005EB8', fontSize: 16, }}>Sistema de Metas Individuais e de Equipe - SGM</Typography>
                  </Grid>
                  <Grid item sm={6}>
                    <Typography style={{ color: '#005EB8', fontSize: 16, }}>Sistema de Gestão Estratégica - SGE</Typography>
                  </Grid>
                  <Grid item sm={6}>
                    <Typography style={{ color: '#005EB8', fontSize: 16, }}>Universidade Corporativa - UC</Typography>
                  </Grid>
                </Grid>
              </div>
              <span style={{float:'right', color:'#005EB8', fontWeight:'bold', fontSize:13, display:'flex', alignItems:'center'}}>Ver todos <ArrowRightAltIcon/></span>
            </div>
          </div>}
        </span> */}
      </div>
    </nav>
  )
}

export default Header;
